import Vue          from 'vue'
import Router       from 'vue-router'
import Dashboard    from '@/components/views/Dashboard/Dashboard'
import SignInPage   from '@/components/views/SignIn/SignInPage'
import Logout       from '@/components/views/Logout/Logout'
import CompleteRegistrationPage
                    from '@/components/views/CompleteRegistration/CompleteRegistrationPage'
import ResetPasswordPage
                    from '@/components/views/ResetPassword/ResetPasswordPage'
import UsersPage    from '@/components/views/Users/UsersPage'
import PageUser
                    from './../components/templates/views/user/PageUser'
import PageDynamicEditorPrint
                    from '../components/templates/views/dynamic-editor-print/PageDynamicEditorPrint'
import Error404     from '@/components/views/Errors/Error404'
import PageDynamicGrid
                    from './../components/templates/views/dynamic-grid/page-dynamic-grid'
import PageDynamicEditor
                    from './../components/templates/views/dynamic-editor/PageDynamicEditor'
import PageDynamicRowEditor
                    from './../components/templates/views/dynamic-row-editor/page-dynamic-row-editor'
import sheduler     from '../components/views/sheduler/scheduler'
import map          from '../components/views/map/map'
import Registration from '../components/views/Registration/Registration'

Vue.use(Router)

let routerOption = {
  mode:   'history',
  routes: [
    {
      path:      '*',
      component: Error404
    },
    {
      path:      '/404',
      name:      '404',
      component: Error404
    },
    {
      path:      '/:company/sign-in',
      name:      'SignInPage',
      component: SignInPage
    },
    {
      path:      '/:company/logout',
      name:      'Logout',
      component: Logout
    },
    {
      path:      '/registration',
      name:      'Registration',
      component: Registration
    },
    {
      path:      '/:company/reset-password/:token',
      name:      'ResetPassword',
      component: ResetPasswordPage
    },
    {
      path:      '/:company/complete-registration/:token',
      name:      'CompleteRegistrationPage',
      component: CompleteRegistrationPage
    },
    {
      path:      '/:company',
      name:      'Dashboard',
      component: Dashboard
    },
    {
      path:      '/:company/users',
      name:      'UsersPage',
      component: UsersPage
    },
    {
      path:      '/:company/user',
      name:      'PageUser',
      component: PageUser,
      props:     true
    },
    {
      path:      '/:company/:page/:idStructure',
      name:      'PageDynamicGrid',
      component: PageDynamicGrid,
      props:     true
    },
    {
      path:      '/:company/:page/:idStructure/edit/:id/:redir/:parent?',
      name:      'PageDynamicEditor',
      component: PageDynamicEditor,
      props:     true
    },
    {
      path:      '/:company/:page/:idStructure/new/:redir/:parent?',
      name:      'PageDynamicEditorNew',
      component: PageDynamicEditor,
      props:     true
    },
    {
      path:      '/:company/print',
      name:      'PageDynamicEditorPrint',
      component: PageDynamicEditorPrint,
      props:     true
    },
    {
      path:      '/:company/:page/:idStructure/row-edit',
      name:      'PageDynamicRowEditor',
      component: PageDynamicRowEditor,
      props:     true
    },
    {
      path:      '/:company/scheduler/:page/:idStructure',
      name:      'scheduler',
      component: sheduler,
      props:     true
    },
    {
      path:      '/:company/map/:page/:idStructure',
      name:      'map',
      component: map,
      props:     true
    }
  ]
}

export default new Router(routerOption)
